import {Filter} from '../../models/warranties/filter.model';

export class FilterService {
  private dashboardFilter: Filter = new Filter();

  resetDashboardFilter() {
    this.dashboardFilter = new Filter();
  }

  getDashboardFilter(): Filter {
    return this.dashboardFilter;
  }
}
